//To be generated on the backend

import { POST, newFetch } from './helpers/fetch'
import { config } from './config/index'
const { API_URL } = config

const publicVapidKey = 'BM9TXf83zLZel5mHYNG-CeIZ0-e2I0Wr5hpdJO-PucOCrnSD5xTCx6vz3MWhgdm_lk_e00RIOWcTjJiK40CS5Jk'
const type = localStorage.getItem('type')
const token = localStorage.getItem('token')

const sendSubscription = subscription => {
  if (type) {
    var checktype = type === 'superadmin' ? 'admin' : type

    let url = `${API_URL}/notification/${checktype}/subscribe`

    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        Authorization: token
      },
      body: JSON.stringify({
        subscription: subscription
      })
    })
  } else {
    console.log('User is not logged in.')
  }
}

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4)
  // eslint-disable-next-line
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/')

  const rawData = window.atob(base64)
  const outputArray = new Uint8Array(rawData.length)

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i)
  }
  return outputArray
}

export function subscribeUser() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then(function(registration) {
        if (!registration.pushManager) {
          console.log('Push manager unavailable.')
          return
        }

        registration.pushManager.getSubscription().then(function(existedSubscription) {
          if (existedSubscription === null) {
            console.log('No subscription detected, make a request.')
            registration.pushManager
              .subscribe({
                applicationServerKey: publicVapidKey,
                userVisibleOnly: true
              })
              .then(function(newSubscription) {
                console.log('New subscription added.')
                sendSubscription(newSubscription)
              })
              .catch(function(e) {
                if (Notification.permission !== 'granted') {
                  console.log('Permission was not granted.')
                } else {
                  console.error('An error ocurred during the subscription process.', e)
                }
              })
          } else {
            console.log('Existed subscription detected.')
            sendSubscription(existedSubscription)
            //   sendAnotherSubscription(existedSubscription);
          }
        })
      })
      .catch(function(e) {
        console.error('An error ocurred during Service Worker registration.', e)
      })
  }
}
